import { render, staticRenderFns } from "./PrimaryRedBag.vue?vue&type=template&id=67babc1f&scoped=true"
import script from "./PrimaryRedBag.vue?vue&type=script&lang=js"
export * from "./PrimaryRedBag.vue?vue&type=script&lang=js"
import style0 from "./PrimaryRedBag.vue?vue&type=style&index=0&id=67babc1f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67babc1f",
  null
  
)

export default component.exports